import React from 'react'

import { XIcon } from 'lucide-react'
import { observer } from 'mobx-react'
import { ChromePicker } from 'react-color'

import './ColorPalette.scss'

interface IProps {
  value: string
  onChange(color: string): void
  onClose(): void
}

interface IColorPickerColor {
  hex: string
}

@observer
export default class ColorPalette extends React.Component<IProps> {
  public render() {
    const { onChange, value, onClose } = this.props
    return (
      <div className="color-palette-container">
        <div className="py8 tw:flex tw:items-center">
          <span className="text bold large tw:flex-1">{`Choose a color`}</span>
          <XIcon
            size={16}
            className="colors-container-cross pointer"
            onClick={onClose}
          />
        </div>
        <ChromePicker
          disableAlpha={true}
          color={value}
          onChangeComplete={(color: IColorPickerColor) => onChange(color?.hex)}
        />
      </div>
    )
  }
}
